import SharedConversation from "./SharedConversation";

export default SharedConversation;
